"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _color = _interopRequireDefault(require("./color"));
var _font = _interopRequireDefault(require("./font"));
var _typeScale = _interopRequireDefault(require("./typeScale"));
var defaultBorder = '1px solid';
var defaultBorderColor = _color.default.aluminium;
var focus = "\n  border-color: ".concat(_color.default.link, ";\n  box-shadow: 0 0 6px 2px rgba(37, 151, 221, 0.22);\n  outline: none;\n");
var padding = '11px 16px 12px';
var text = "\n  ".concat(_typeScale.default.input, "\n  color: ").concat(_color.default.gunMetal, ";\n  font-family: ").concat(_font.default.primaryRegular, ";\n");
var paddingDropdownLast = "\n  padding-bottom: inherit;\n  border-radius: inherit;\n";
var borderRadius = '2px';
var input = {
  default: "\n    ".concat(text, "\n\n    appearance: none;\n    background-color: ").concat(_color.default.white, ";\n    border: ").concat(defaultBorder, " ").concat(defaultBorderColor, ";\n    outline: 1px solid transparent;\n    border-radius: 2px;\n    box-sizing: border-box;\n    margin: 0;\n    padding: ").concat(padding, ";\n    width: 100%;\n\n    &:focus {\n      border: 1px solid ").concat(_color.default.secondary, ";\n      outline: 1px solid ").concat(_color.default.secondary, ";\n    }\n\n    &:disabled {\n      background-color: ").concat(_color.default.ash, ";\n      border-color: ").concat(_color.default.aluminium, ";\n      color: ").concat(_color.default.aluminium, ";\n    }\n  "),
  defaultBorderColor: defaultBorderColor,
  errorBorderColor: _color.default.error,
  focus: focus,
  padding: padding,
  text: text,
  paddingDropdownLast: paddingDropdownLast,
  borderRadius: borderRadius
};
var _default = exports.default = input;